import { useParams } from "react-router-dom";
import useUser from "../hooks/useUser";
import useLastUserMedal from "../hooks/useLastUserMedal";
import AdminEditMedals from "../components/AdminEditMedals";
import UserMedal from "../interfaces/userMedal";
import AdminSetAdmin from "../components/AdminSetAdmin";

const AdminEditProfile = () => {
    const { username } = useParams();
    const {
    data: medals,
    isLoading: isLoadingBadges,
    error: errorBadges,
  } = useLastUserMedal(username) as {
    data: UserMedal[] | null;
    isLoading: boolean;
    error: any;
  };
  const {
    data: user,
    isLoading: isLoadingUser,
    error: errorUser,
  } = useUser(username);

  if(errorUser || errorBadges) return <>Error while loading data.</>
  if(isLoadingBadges || isLoadingUser) return <>Loading...</>
    return (
        <div>
          <div>{user?.username}</div>
          <AdminEditMedals medals={medals} userId={user?.id}/>
          <AdminSetAdmin userId={user?.id} isAdmin={user?.isAdmin!}></AdminSetAdmin>
        </div>
    )
}

export default AdminEditProfile;